<template>
  <div class="car-detail-hero-info">
    <CarDetailOverview v-if="objectHasEntries(carData)" :api-status="apiStatus" @update:variant-update="onVariantUpdate" :car-data="carData" />
    <div :class="{ 'skeleton-box': apiStatus === 'LOADING' }">
      <CarDetailKeyStats v-if="objectHasEntries(carData)" :key="updated" :car-data="carData" :api-status="apiStatus" />
    </div>
    <CarDetailANCAPRating :date-tested="carData?.ANCAP_Date_tested" :ancap-score="carData?.ANCAP_Overall_score || 'N/A'" :api-status="apiStatus" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import CarDetailKeyStats from './CarDetailKeyStats.vue';
import CarDetailOverview from './CarDetailOverview.vue';
import CarDetailANCAPRating from './CarDetailANCAPRating.vue';
import { ApiStatusTypes } from '../../foundation/types/apiStatusTypes';
import { objectHasEntries } from '../../foundation/helpers';

const props = defineProps<{
  apiStatus: ApiStatusTypes;
  carData: any;
}>();

const emit = defineEmits<{
  (e: 'update:variantUpdate', vehicleId: string): void;
}>();

const updated = ref(1);

function onVariantUpdate(vehicleId: string) {
  emit('update:variantUpdate', vehicleId);
  updated.value += 1;
}
</script>

<style lang="scss" scoped>
.car-detail-hero-info {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  width: 100%;

  @media screen and (min-width: #{$breakpoint-xl}) and (max-width: #{$breakpoint-xxl}) {
    width: 30%;
  }
}
</style>
